export default __webpack_public_path__ + "static/Trazable_Logo_W-578c673ea191b346da899c01c1ae0a90.png";